<template>
  <div class="userPartner-report_closedTable Owning close-order-page white">
    <div
      v-if="detailsIsMaster"
      class="header"
    >
      <el-date-picker
        v-if="!realMobile"

        class="input-box header-sub-item date-picker-el"
        size="small"
        v-model="query.pickerTime"
        type="daterange"
        align="left"
        unlink-panels
        value-format="yyyy-MM-dd HH-mm-ss"
        :range-separator="phFileter('root.dateTo')"
        :start-placeholder="phFileter('root.startDate')"
        :end-placeholder="phFileter('root.endDate')"
      >
      </el-date-picker>
      <select-date-duration
        class="header-sub-item"
        v-model="query.pickerTime"
      ></select-date-duration>
      <el-select
        size="small"
        class="Recharge input-box header-sub-item select-option-el"
        v-model="tradeType"
        :placeholder="phFileter('User.reportCmd')"
        clearable
      >
        <el-option
          v-for="item in classTypeList"
          :key="item.value"
          :label="item.label"
          :value="item.value"
        >
        </el-option>
      </el-select>
      <el-select
        v-if="needOrderSource"
        size="small"
        class="Recharge input-box header-sub-item"
        v-model="orderSource"
        :placeholder="phFileter($t('orderSource'))"
        clearable
      >
        <el-option
          v-for="item in orderSourceList"
          :key="item.value"
          :label="item.label"
          :value="item.value"
        >
        </el-option>
      </el-select>
      <el-button
        class="ele-el header-sub-item"
        size="small"
        type="primary"
        @click="queryHandle"
      >{{ $t('root.search') }}
      </el-button>
      <el-button
        class="ele-el header-sub-item"
        size="small"
        @click="exportHandle"
      >{{ $t('root.export') }}
      </el-button>
      <el-button
        class="ele-el header-sub-item"
        size="small"
        @click="clearHandle"
      >{{ $t('withgold.clearEmipt') }}
      </el-button>
    </div>
    <el-table
      :data="listData"
      v-loading="loading"
      :empty-text="$t('root.noData')"
      class=""
      @sort-change="sortChange"
      :header-cell-style="{ background: '#F3F2F7',color: '#5E5873' }"
    >
      <div class="table-nodata" slot="empty">
        {{ $t('root.noData') }}
      </div>
      <el-table-column
        prop="order"
        :label="$t('User.reportOrderId')"
      >
      </el-table-column>
      <el-table-column
        :label="$t('User.reportSymbol')"
        prop="symbol"
        sortable
      >
      </el-table-column>
      <el-table-column
        :label="$t('User.reportCmd')"
        min-width="110px"
      >
        <template slot-scope="scope">
          <span>{{ scope.row.cmd % 2 == 0 ? phFileter('User.buy') : phFileter('User.sell') }}</span>
          <el-tooltip class="item" effect="dark" :content="`${$t('signal_source')}: ${scope.row.masterAlias}`"
                      placement="top">
                      <span
                        v-if="scope.row.reason === 0"
                        class="copy-tag">{{ 'COPY' }}</span>
          </el-tooltip>
        </template>
      </el-table-column>
      <el-table-column
        :label="$t('User.reportVolume')"
        prop="volume"
        min-width="130px"
        sortable
      />
      <el-table-column
        :label="$t('Open_a_position') + '/' + $t('User.reportCloseTime')"
        min-width="160px"
        prop="openTime"
        sortable
      >
        <template slot-scope="scope">
          <div>{{ parseTime(scope.row.openTime) }}</div>
          <div>{{ parseTime(scope.row.closeTime) }}</div>
        </template>
      </el-table-column>
      <el-table-column
        :label="$t('Open_a_position') + '/' + $t('User.reportClosePrice')"
        min-width="160px"
        prop="openPrice"
        sortable
      >
        <template slot-scope="scope">
          <div>{{ scope.row.openPrice || '-' }}</div>
          <div>{{ scope.row.closePrice || '-' }}</div>
        </template>
      </el-table-column>
      <el-table-column
        :label="$t('User.reportTp') + '/' + $t('User.reportSl')"
        min-width="160px"
      >
        <template slot-scope="scope">
          <div>{{ scope.row.tp || '-' }}</div>
          <div>{{ scope.row.sl || '-' }}</div>
        </template>
      </el-table-column>
      <el-table-column
        :label="$t('commission')"
        prop="commission"
        sortable
        min-width="100px"
      >
      </el-table-column>
      <el-table-column
        :label="$t('User.reportStorage')"
        prop="storage"
        sortable
      >
      </el-table-column>
      <el-table-column
        :label="$t('User.reportProfit')"
        prop="profit"
        sortable
      >
        <template slot-scope="scope">
                  <span class="profit profit-words"
                        :class="{on: getActive(scope.row)}"
                  >{{ scope.row.profit }}</span>
        </template>
      </el-table-column>
    </el-table>
    <div class="pagination-outer" v-if="total">
      <div class="paginnation-left">
        <size-change @sizeChange="sizeChange"></size-change>
        <span class="tatol-count">{{ $t('total') }} {{ total }} {{ $t('item') }}</span>
      </div>
      <vs-pagination
        class="pagination-box"
        :max="max"
        :total="pageSize"
        v-model="page"
      ></vs-pagination>
    </div>
  </div>
</template>

<script>
import {mapGetters} from 'vuex'
import {limitNumber} from '@/utils/validate'
import {parseTime} from '@/utils/index'
import {getCustType} from '@/utils/common';
import initData from '@/mixins/initData';
import {export_json_to_excel, formatJson} from '@/vendor/Export2Excel'
import request from '@/utils/ajax';

export default {
  name: 'report_closedTable',
  props: {
    dateTime: {
      type: Object,
    },
    needOrderSource: {
      type: Boolean,
      default: false,
    }
  },
  data() {
    return {
      classTypeList: [
        {
          value: 0,
          label: this.$t('User.buy')
        }, {
          value: 1,
          label: this.$t('User.sell')
        },
      ],
      symbolVariety: '',
      symbolVarietyList: [],
      belongAgency: '',
      statistics: {
        volumeSum: '',
        profitSum: '',
      },
      tradeType: '',
      orderSource: '',
      orderSourceList: [
        {
          label: this.$t('Documentary_transactions'),
          value: 0,
        },
        {
          label: this.$t('autonomous_transaction'),
          value: 1,
        },
      ],
    }
  },
  mixins: [initData],
  computed: {
    ...mapGetters(['userInfo', 'detailsIsMaster', 'realMobile']),
  },
  mounted() {
    this.$nextTick(() => {
      this.init();
    })
  },
  methods: {
    parseTime,
    limitNumber,
    getActive(row) {
      if ((row.profit + '').indexOf('-') > -1) {
        return true;
      } else {
        return false;
      }
    },
    beforeInit() {
      this.url = '/crm/reception/queryOrders';
      this.params = {
        page: this.page - 1,
        size: this.size,
        orderType: 3,
        mtId: this.$route.params.mtid,
      };
      if (this.query.pickerTime) {
        this.params.startTime = this.query.pickerTime[0];
        this.params.endTime = this.query.pickerTime[1];
      }
      if (this.tradeType !== '') {
        this.params.cmd = this.tradeType;
      }
      if (this.sort) {
        this.params.sort = this.sort;
      }
      if (this.needOrderSource) {
        if (this.orderSource !== '') {
          this.params.reason = this.orderSource;
        }
      }
      if (this.dateTime) {
        this.params.beginDate = parseTime(this.dateTime.beginDate);
        this.params.endDate = parseTime(this.dateTime.endDate);
      }
      return true;
    },
    phFileter(data) {
      return this.$t(data);
    },
    //  清空
    clearHandle() {
      this.orderSource = '';
      this.tradeType = '';
      this.query.pickerTime = '';
    },
    queryHandle() {
      this.page = 1;
      this.init();
    },
    exportHandle() {
      let _this = this;
      let params = {
        export: 1,
        orderType: 3,
        mtId: +this.$route.params.mtid,
      }
      if (this.query.pickerTime) {
        params.startTime = this.query.pickerTime[0];
        params.endTime = this.query.pickerTime[1];
      }
      if (this.tradeType !== '') {
        params.cmd = this.tradeType;
      }
      if (this.sort) {
        params.sort = this.sort;
      }
      if (this.needOrderSource) {
        if (this.orderSource !== '') {
          params.reason = this.orderSource;
        }
      }
      if (this.dateTime) {
        params.beginDate = parseTime(this.dateTime.beginDate);
        params.endDate = parseTime(this.dateTime.endDate);
      }
      request({
        url: this.url,
        method: 'get',
        params: params,
        addToken: true,
      }).then((res) => {
        if (!res.data.content.length) return;
        const tHeader = ['订单号(Order)', '品种(Symbol)', '交易类型(Transaction Type)', '交易量(Volume)', '建仓时间(Open Time)', '建仓价格(Open price)', '平仓时间(Close time)', '平仓价格(Close price)', '止损(Sl)', '止盈(Tp)', '手续费(Commission)', '利息(Storage)', '盈亏(Profit)',];
        const filterVal = ['order', 'symbol', 'cmd', 'volume', 'openTime', 'openPrice', 'closeTime', 'closePrice', 'sl', 'tp', 'commission', 'storage', 'profit'];
        for (let i = 0; i < res.data.content.length; i++) {
          res.data.content[i].openTime = parseTime(res.data.content[i].openTime);
          res.data.content[i].closeTime = parseTime(res.data.content[i].closeTime);
          res.data.content[i].custType = this.getCustTypeSelf(res.data.content[i]) || '-';
          res.data.content[i].cmd = res.data.content[i].cmd % 2 == 0 ? _this.$t('User.buy') : _this.$t('User.sell');

        }

        const exportData = formatJson(filterVal, res.data.content);
        let fileName = '已平仓单报表';
        export_json_to_excel(tHeader, exportData, fileName);
      })
    },
    getCustTypeSelf(row) {
      if (row.custType == 0) {
        return this.$t('User.reportDir');
      } else if (row.custType == 1) {
        return this.$t('User.reportIndir');
      }
    }
  },
};
</script>
<style scoped lang="scss">
.userPartner-report_closedTable {
  min-height: 500px;

  .header-sub-item {
    margin-bottom: 10px;
  }
}
</style>

